// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_b8642572","message":"_e542aeaa","linkContainer":"_6858c3c6","link":"_5d3b4201"};